import { QidProduct } from "server/models"
import { OrderType, inferLiteral } from "client/utils"
import * as types from "./types"


export const setQidProductList = (productList: types.QidProductList) => ({
    type: inferLiteral(types.QID_PRODUCT_LIST),
    productList,
})
export const setQidProductIds = (productIds: readonly number[]) => ({
    type: inferLiteral(types.QID_PRODUCT_IDS),
    productIds,
})
export const setQidProductView = (product: QidProduct) => ({
    type: inferLiteral(types.QID_PRODUCT_VIEW),
    product,
})
export const setQidProductEdit = (product: QidProduct) => ({
    type: inferLiteral(types.QID_PRODUCT_EDIT),
    product,
})
export const setQidProductFolderId = (folderId: number) => ({
    type: inferLiteral(types.QID_PRODUCT_FOLDER_ID),
    folderId,
})
export const setQidProductSort = (sortColumn: keyof QidProduct, sortOrder: OrderType) => ({
    type: inferLiteral(types.QID_PRODUCT_SORT),
    sortColumn,
    sortOrder,
})
export const setQidProductFilters = (filters: types.QidProductFilters) => ({
    type: inferLiteral(types.QID_PRODUCT_FILTERS),
    filters,
})
export const setQidProductReloadList = (value: boolean) => ({
    type: inferLiteral(types.QID_PRODUCT_RELOAD_LIST),
    value,
})
export const setQidProductReloadView = (value: boolean) => ({
    type: inferLiteral(types.QID_PRODUCT_RELOAD_VIEW),
    value,
})
export const setQidProductReloadEdit = (value: boolean) => ({
    type: inferLiteral(types.QID_PRODUCT_RELOAD_EDIT),
    value,
})
